import { ControllerManager } from '@gui/controller/ControllerManager';
import { Box, Button } from '@mui/material';
import { MixerElement } from '@visualizer/types';
import React, { useEffect } from 'react';
import usePersistentStore, { getGlobalState } from '../../../store/persistent/persistentStore';
import MixerRow from './MixerRow';
import { MixerActions } from './MixerTypes';

const EMPTY_MIXER_ELEMENTS: MixerElement[] = [];

const MultiMode: React.FC = () => {
    const mixerElements = usePersistentStore((s) => s.layers.layerStates.mixed?.mixerElements ?? EMPTY_MIXER_ELEMENTS);
    const getMixerController = () => ControllerManager.getInstance().getMixerController();

    useEffect(() => {
        const mixerController = getMixerController();
        mixerController.toggleMultiMode(true);
        return () => {
            mixerController.toggleMultiMode(false);

            if (getGlobalState().data.isMixerMode) {
                // When going from multi to mixer, run mixerController to update the singleDraw with the mixed layer values:
                mixerController.run();
            } else {
                // When going from multi to data, run current pipeline to update the singleDraw with the correct, non mixed-layer values:
                ControllerManager.getInstance().getPipelineController().run();
            }
        };
    }, []); // run only on mount/unmount

    const actions = (action: MixerActions, layerId?: string) => {
        const mixerController = getMixerController();
        switch (action) {
            case MixerActions.DELETE: {
                mixerController.deleteLayer(layerId as string);
                break;
            }

            case MixerActions.DELETE_ALL: {
                mixerController.deleteAllLayers();
                break;
            }

            case MixerActions.TOGGLE_VISIBLE: {
                mixerController.toggleVisible(layerId as string);
                break;
            }

            case MixerActions.TOGGLE_TRANSPARENCY: {
                mixerController.toggleTransparency(layerId as string);
                break;
            }

            default:
                console.warn(`Unknown multimode action: ${action}`);
                break;
        }
    };

    return (
        <div className="multi-mode">
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 0.5 }}>
                <Button
                    size="small"
                    variant="contained"
                    color="error"
                    disabled={mixerElements.length === 0}
                    onClick={() => actions(MixerActions.DELETE_ALL)}
                >
                    Delete all
                </Button>
            </Box>

            {/* Show number of elements */}
            {/* <div style={{ marginBottom: '1rem', fontWeight: 'bold' }}>
                Number of elements: {mixerElements.length}
            </div> */}

            {/* Reuse MixerRows, but in multimode */}
            {mixerElements.map((el) => (
                <MixerRow
                    key={el.layerId}
                    mixerElement={el}
                    actions={actions} // no weight/invert actions in multimode
                    multimode={true}
                />
            ))}
        </div>
    );
};

export default MultiMode;
